import React from "react";
import { useParams, Link } from "react-router-dom";
import { EmptyState } from "../components/states/EmptyState";

/**
 * BIAs — placeholder. In Phase 5 the BIA data is only accessible via a run's
 * dataset tab (`/w/:ws/analyses/:runId` → Dataset). We keep this route so
 * the sidebar nav item works without dead-ending.
 */
export default function BIAsPage() {
  const { workspaceId } = useParams();
  return (
    <div className="space-y-6">
      <header>
        <div className="text-xs uppercase tracking-widest text-slate-500">
          BIAs
        </div>
        <h1 className="mt-1 text-2xl font-semibold text-slate-900">
          Business Impact Analyses
        </h1>
      </header>
      <EmptyState
        title="BIA browsing lives inside a run"
        description="Every canonical BIA record is pinned to the analysis run it was ingested into. Open an analysis to browse its dataset — that keeps historical BIAs immutable."
        action={
          <Link
            to={`/w/${workspaceId}/analyses`}
            data-testid="bias-open-analyses"
            className="rounded bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
          >
            Open analyses
          </Link>
        }
      />
    </div>
  );
}
